<template>
 <div class="container">
  <form @submit.prevent class="login-form-box change-password-page contact-page">
  <h4 class="welcome-text change-password-text">Contact Us</h4>
    <div class="contact-us-container">
      <v-row>
        <v-col class="form-caption">
          <h4 class="title">Get In Touch</h4>
          <p>We are here for you. How can we help you?</p>
        </v-col>
      </v-row>
      <div class="form-container">
        <v-row class="information">
        <v-col class="info-inner">
          <h4 class="drop-message">Drop A Message</h4>
        </v-col>
      </v-row>
       <v-row>
          <v-col class="container">
            <v-text-field
            v-model="name"
            label="FULL NAME"
            value=""
            :error-messages="subjectErrors"
            placeholder="Enter name"
            readonly
            ></v-text-field>
          </v-col>
           <v-col class="container">
            <v-text-field
            v-model="email"
            label="EMAIL ADDRESS"
            value=""
            :error-messages="subjectErrors"
            placeholder="Enter email"
            readonly
            ></v-text-field>
          </v-col>
        </v-row>
       <v-row>
          <v-col class="container">
            <v-text-field
            v-model="subject"
            label="Subject"
            value=""
            :error-messages="subjectErrors"
            placeholder="Enter Subject"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="container">
      			<v-textarea
      			v-model="contactUs"
      			label="Message"
      			value=""
      			:error-messages="contactUsErrors"
      			placeholder="Enter Message"
            max-rows="6"
            :maxlength="max"
      			></v-textarea>
          </v-col>
        </v-row>
        <div class="button-row">
          <div class="button-holder">
            <v-btn
                class="blue-btn btn"
                @click="cancelSendMsg"
              >
              Cancel
            </v-btn>
          </div>
            
           <div class="button-holder">
              <v-btn
                class="blue-btn btn"
                @click="submit" :disabled="!isFormValid" :error-messages="buttonErrorMessage"
              >
                SEND
              </v-btn>
           </div>
        </div>
      </div>
    </div>
  </form>
  <modal class="common-modal-box small-modal-box" name="contactUSservices"> 
    <span> 
      <v-img width="20" height="20" @click="closeContactUSservices" style="float: right;" :src="require('@/assets/images/cross.png')">
      </v-img>
    </span>
    <p>Thank you for contacting us. We will get back to you soon.</p>
  </modal>
</div>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  sameAs,
  isAlphanumeric
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import { POST_API, GET_API } from "../../store/actions.type";
import ApiService from "../../api/api.service";
import JwtService from ".././common/jwt.service";

export default {
  mixins: [validationMixin],

  validations: {
    contactUs: { required },
    subject: { required },
  },

  data: () => ({
    contactUs: '',
    subject: '',
    submitted: false,
    serverError:'',
    isFormValid:false,
    name:'',
    email:'',
    contactUsCheck:'',
    max:1000,
  }),

  computed: {
    contactUsErrors() {
     (this.contactUs.length >= 1000 )? (this.contactUsCheck = 1000) : '';
    },
     subjectErrors() {
     (this.contactUs.length >= 3 )? (this.contactUsCheck = 3) : '';
    },
    buttonErrorMessage(){
      if (this.$v.$invalid) {
          this.isFormValid = false;
        }else{
          this.isFormValid = true;
        }
    }
  },

  methods: {
    cancelSendMsg(){
        this.$router.push({ name: "dashboard"}).catch(()=>{});
    },
    submit(e) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.$store.getters.getUserDetails.user_name) {
        // let cognito_idp = this.authUser.cognito_idp;
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        // this.authenticatedUserData();
        let name = this.$store.getters.getUserDetails.user_name;
        let email = this.$store.getters.getUserDetails.email;
        this.$loading(true)
        const contact = this.contactUs;  
          this.$store
            .dispatch(POST_API, {
              data: {
               subject: this.subject,
               detail: contact,
               aws_cognito_id: cognito_idp,
               name:name,
               email:email,
              },
              api: "save-contact-detail"
            })
            .then(() => {
              this.$loading(false);
              this.contactUs = '';
              this.subject = '';
              // this.$modal.show("contactUSservices");
              swal.fire({
                html:'<img src="./22.svg"/><br><p>Thank you for contacting us. We will get back to you soon.</p>',
                showCancelButton: false,
                confirmButtonColor: '#051d42',
                confirmButtonText: 'OK',
                });
            }).catch((error) => {
              this.$loading(false);
            });
     
      }
    },
    // closeContactUSservices(){
    //     this.$modal.hide("contactUSservices");
    //   },
   
    authenticatedUserData() {
      Auth.currentAuthenticatedUser({
        bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then(user => {
          this.name = user.attributes["custom:name"];
          this.email = user.attributes["email"];
        })
        .catch(err => {
          this.$loading(false);
        });
    }
  },
  mounted(){
    this.authenticatedUserData();
  }

};
</script>